








import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Listing } from '../models/Listing';

@Component
export default class PhotoPanel extends Vue {

    get selectedListingImage(): string | null {
        if (this.selectedListing?.pi && this.config.imageRoot) {
            let relativePath = this.selectedListing.pi;
            if (relativePath.indexOf(this.config.placeholdListingImg) === -1) {
                relativePath = this.config.imageRoot + relativePath;
            }
            return relativePath;
        }
        return null;
    }

    get selectedListing(): Listing | null {
        return this.$store.state.listings.selectedListing;
    }

    get config() {
        return this.$store.state.config;
    }

    public mounted() {
        this.$store.dispatch('showLightBox');
    }

    public onClick() {
        this.$store.dispatch('showLightBox');
    }
}
